import { HeaderWellmaxx } from './HeaderWellmaxx'

export default HeaderWellmaxx
